<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!showOSSelect">
        <div class="form-edit-page row-space">
            <div v-if="osSelecionada" class="row row-space">
                <div class="form-item-codigo">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ osSelecionada.cdos }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Inclusão</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osSelecionada.dtinclusao) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ osSelecionada.nmpessoa }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Serviço</label>
                    <div class="field-label">{{ osSelecionada.nmservico }}</div>
                </div>
            </div>

            <div v-if="ckExisteEventos" class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Justificativa</label>
                    <input type="text" v-uppercase v-model="edInfoCancelamento" />
                </div>
            </div>

            <div class="row-end">
                <button v-if="ckExisteEventos" class="btn-cancel" @click="submitForm">Estornar Eventos</button>
                <button @click="openOSSelect">Retornar</button>
            </div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th class="col-width-date">Data</th>
                    <th class="col-width-date">Hora</th>
                    <th>Descrição</th>
                    <th class="col-width-char30">Operador</th>
                    <th class="col-width-char30">Observações</th>
                    <th class="col-width-char10">Horas/Km</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtevento) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatTimeFromJson(obj.hrevento) }}</td>
                    <td>{{ obj.xtpevento }}</td>
                    <td class="col-width-char30">{{ obj.nmoperador }}</td>
                    <td class="col-width-char30">{{ obj.obs }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.horaskm) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="showOSSelect">
        <OsPesquisaPage
            @cancel="closeForm"
            @select="selecionarOS" />
    </div>


    <DialogOkModal 
      v-if="showOkModal" 
      :message="msgOkModal" 
      @close="closeOkModal" 
      @confirmed="closeOkModal" />
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericGet, genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OsPesquisaPage from './OsPesquisaPage.vue';

const emit = defineEmits(['close']);
const ckExisteEventos = ref(false);
const edInfoCancelamento = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(false);
const showOSSelect = ref(true);

const msgOkModal = ref(null);
const showOkModal = ref(false);

// OBJETOS
const osSelecionada = ref(null);

const closeForm = () => {emit('close');};

function closeOkModal() {
    emit('save');
    showOkModal.value       = false;
    showOSSelect.value      = true;
}

const openOSSelect = () => {
    msgAlerta.value=null;
    showOSSelect.value=true;
}

const selecionarOS = async(os) => {    
    try{
        showOSSelect.value      = false;
        osSelecionada.value     = os;
        msgAlerta.value         = null;
        isLoading.value         = true;
        const h = await genericGet('/os/historico', {id: osSelecionada.value.id});
        lsDados.value = h;
        if (lsDados.value.length===0){
            ckExisteEventos.value=false;
            msgAlerta.value='OS não possui eventos para estornar';
        }else{
            ckExisteEventos.value=true;
        }
    }catch (error){msgAlerta.value = error;
    }finally{isLoading.value = false;}
};

const submitForm = async () => {
    try{
        msgAlerta.value=null;
        if (!edInfoCancelamento.value) throw new Error('Informe a justificativa');
        isLoading.value=true;
        const ret = await genericPost('/main/exec_requisicao', {
            nmrequisicao: 'os_estornar_eventos',
            idmunicipio: globalStore.idmunicipio,
            idos: osSelecionada.value.id,
            strparam1: edInfoCancelamento.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (ret.bolok === 1){
            msgOkModal.value=`Eventos da OS ${osSelecionada.value.cdos} estornados com sucesso`;
            showOkModal.value=true;
        }else{
            msgAlerta.value=`ATENÇÃO: ${ret.erro}`;
        }
    }catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}
</script>
